import React from "react";
import Modal, { ModalProps } from "../Modal";
import Loading, { LoadingProps } from "../Loading";
import "./ModalLoadingScreen.css";

export interface ModalLoadingScreenProps
  extends Pick<
      ModalProps,
      Exclude<
        keyof ModalProps,
        "allowOpen" | "bodyOpenClassName" | "onClose" | "children"
      >
    >,
    Pick<LoadingProps, Exclude<keyof LoadingProps, "children">> {
  children?: React.ReactNode | React.ReactNodeArray;
}

export default function ModalLoadingScreen({
  message,
  isOpen = true,
  className = "modal loading-screen",
  overlayClassName = "modal-overlay",
  children
}: ModalLoadingScreenProps) {
  const modalProps = {
    allowClose: false,
    isOpen,
    className,
    overlayClassName
  };

  return (
    <Modal {...modalProps}>
      <Loading message={message} />
      {children}
    </Modal>
  );
}
